export enum AccountStatusBannerType {
  NONE = 'none',
  ACCOUNT_SUSPENDED = 'account_suspended',
  ACCOUNT_DISABLED = 'account_disabled',
  ACCOUNT_TERMINATED = 'account_terminated',
  TRIAL_EXPIRING = 'trial_expiring',
  TRIAL_EXPIRED = 'trial_expired',
  ACCOUNT_EXPIRED = 'account_expired'
}

export enum SubscriptionType {
  TRIAL = 'trial',
  SUBSCRIPTION = 'subscription'
}

export interface AccountStatusBanner {
  banner_type: AccountStatusBannerType
  expires_at: number
  trial_days_remaining: number
  subscription_type?: SubscriptionType
}

export interface RiskyConfigBannerDisabled {
  kind: 'disabled'
  reason: string
}

export interface RiskyConfigBannerEnabled {
  kind: 'enabled'
  targetUrl: string
}

export type RiskyConfigBanner = RiskyConfigBannerDisabled | RiskyConfigBannerEnabled

export interface BannerSettings {
  hasMailFlown: boolean
  wizardComplete: boolean
  hasVerifiedDomains: boolean
  accountStatusBanner: AccountStatusBanner
  riskyConfigBanner: RiskyConfigBanner
  // BNESS-31630: Feature flag for wizard exit redirect to message-log after region selection
  wizardExitToMessageLogEnabled?: boolean
}
